/* eslint-disable */

<template>
    <div ref="client_list" class="ma-0 pa-0">
        <!--BasicCard v-if="o_loading" >
            <v-card-text class="xs12 text-center">
                <v-progress-circular
                indeterminate
                size="64"
                width="7"
                color="primary"
                ></v-progress-circular>
            </v-card-text>
        </BasicCard-->
        <BasicCard :show_title="false">
            <div>
                <v-container>
                    <v-row no-gutters class="mb-4">
                        <v-col cols="12" class="d-flex justify-end">
                            <v-btn 
                            v-can="{obj_type:'client', action: 'edit'}" 
                            color="action" class="ml-2" @click="newClient">
                            <v-icon class="pa-2" small>add_box</v-icon> Nuovo cliente
                            </v-btn>
                        </v-col>
                    </v-row>
                    <div v-if="advanced_search">
                    
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex flex-row justify-space-between align-content-center">
                            <span class="text-h6">Ricerca avanzata</span>
                            <span><v-btn fab small text @click.stop="cancelSearch()"><v-icon>close</v-icon></v-btn></span>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="6"  class="d-flex justify-start align-content-center pr-2">
                            <v-text-field dense outlined
                                label="nome/PIVA"
                                v-model="filter.search"
                                clearable
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="d-flex justify-start align-content-center">
                            <v-text-field dense outlined
                                label="contatto"
                                v-model="filter.contact_search"
                                clearable
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="6" class="d-flex justify-start align-content-center pr-2">
                            <v-combobox dense outlined
                                    label="provincia"
                                    v-model="filter.district"
                                    :items="districts.districts"
                                    item-value="id"
                                    item-text="name"
                                    return-object
                                    clearable
                                ></v-combobox>
                        </v-col>
                        <v-col cols="6" class="d-flex justify-start align-content-center">
                            <v-combobox dense outlined
                                    label="città"
                                    v-model="filter.city"
                                    :items="districts.cities"
                                    item-value="id"
                                    item-text="name"
                                    return-object
                                    clearable
                                ></v-combobox>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex justify-center align-content-center pa-2">
                            <v-btn color="primary" class="d-flex align-content-center text-center" @click="search"><v-icon class="pr-2">search</v-icon>Cerca</v-btn>
                            <v-btn color="action" class="text-center ml-2" @click="cancelSearch">annulla</v-btn>
                        </v-col>
                    </v-row>
                    
                    <v-divider class="mt-4" />
                    </div>
                    <div v-if="filtered_org && !advanced_search">
                        <div class="text-h6">Ricerca in tutto il sistema</div>
                            <v-row no-gutters>
                                <v-col cols="6"  class="d-flex justify-start align-content-center pr-2">
                                    <v-text-field dense outlined
                                        label="PIVA"
                                        v-model="search_piva"
                                        clearable
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="6" class="d-flex justify-start align-content-center">
                                    <v-btn color="primary" class="d-flex align-content-center text-center" @click="exactSearch"><v-icon class="pr-2">search</v-icon>Cerca</v-btn>
                                    <v-btn color="action" class="text-center ml-2" @click="cancelSearch">annulla</v-btn>
                                </v-col>
                            </v-row>
                        </div>
                        <v-divider />
                        <v-row no-gutters>
                        <v-col cols="12" class="d-flex flex-row justify-space-between align-content-center mt-4">
                            <span><v-autocomplete dense outlined
                                    label="ordina per"
                                    v-model="sort_fields"
                                    :items="sorting_fields"
                                    item-value="value"
                                    item-text="label"
                                    return-object
                                    hide-details
                                    @change="changeOrder"
                                ></v-autocomplete>
                            </span>
                            <span v-if="!advanced_search"><v-btn color="primary" @click.stop="openAdvancedSearch"><v-icon class="mr-2">filter_list</v-icon>filtra</v-btn></span>
                        </v-col>
                    </v-row>
                    
                </v-container>
            </div>
            <div v-if="!searching">
                <v-data-table
                    :items="objects"
                    dense
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    hide-default-header
                    hide-default-footer
                    @page-count="pageCount = $event">
                    <template v-slot:body="{ items }">
                        <tbody >
                            <div v-if="objects.length == 0" class="px-2 text-h6 text-center">
                                Nessun cliente trovato
                            </div>
                            <tr class="pa-0 ma-0" v-for="client in items" :key="client._id">
                                <td>
                                <ClientItem 
                                    v-bind:client_id="client._id"
                                    @client_removed="updateSearch"
                                />
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
                <div v-if="objects.length > 0" class="text-center pa-2">
                    <div class="text-right font-italic font-small">Totale: {{ this.objects.length }}</div>
                    <v-pagination v-if="pageCount > 1" v-model="page" :length="pageCount" :total-visible="7"></v-pagination>
                </div>
            </div>
            <div v-else>
                <v-card-text class="xs12 text-center">
                    <v-progress-circular
                    indeterminate
                    size="64"
                    width="7"
                    color="primary"
                    ></v-progress-circular>
                </v-card-text>
            </div>
        </BasicCard>
        <ClientDialog
            ref="clientEdit"
            v-on:addClient="goToClientDetails"
        />
    </div>
</template>

<script>
// import _ from 'lodash'
import ClientDialog from "./ClientDialog"
import ClientItem from "./ClientItem"
import {ListManagement} from "../../utils/listMixin"
import BasicCard from '../../components/utils/Basic_card'
import { filterByOrg, useRemoteConnection } from '../../utils/rolesManagement'
import {support_db} from "../../utils/dbUtility"

export default {
    components: {ClientDialog, ClientItem, BasicCard},
    mixins: [ListManagement],
    data(){
        return {
            searching: true,
            db: "registry",
            new_client_dialog: false,
            filter: {
                city: '',
                district: '',
                contact_search: "",
                search: ""
            },
            o_selector: {doc_type:'client', status: {"$ne": 'deleted'}},
            selector: {},
            sorting_fields: [
                {label: 'nome cliente', value: ['value.name', 'value.updated'], order: ['asc', 'asc']},
                {label: 'modifica', value:['value.updated', 'value.name'], order: ['desc', 'asc']}
            ],
            sort_fields: {},
            page: 1,
            itemsPerPage: 10,
            pageCount: 0,
            districts: {},
            search_piva: null,
            list_type: 'client'
        }
    },
    beforeDestroy() {
        this.districts = null
        this.objects = null
        this.filter = null
        //console.log("CLIENT LIST", this.$refs.client_list)
    },
    methods: {
        resetSearch(){
            this.filter = {
                city: null,
                district: null,
                contact_search: "",
                search: ""
            };
            this.$store.commit('setSearchParam', {path: this.$router.history.current.fullPath, filter: null, page:1, sort_fields: this.sorting_fields[0]})
        },
        newClient(){
            this.$refs.clientEdit.openDialog(true);
        },
        updateSelector(selector) {
        },
        goToClientDetails(client) {
            console.log('GO TO CLIENT DETAILS')
            this.$store.commit('setSearchParam', { path: this.$router.history.current.fullPath, filter: this.filter, page: this.page, sort_fields: this.sort_fields })
            this.$router.push({path: "/clients/details", query: {"client_id": client._id, "back": this.$router.history.current.fullPath}})
        },
        refreshClient() {
            this.sort_fields = this.sorting_fields[0]
            this.updateSearch()
        },
        customSelection(){
            // to be implemented with search
            if (this.customSelector.ids) {
                this.selector['_id'] = {'$in': this.customSelector.ids}
            } 
        },
        initSelector() {

        },
        openFilter(){
            this.filter.show = true
        },
        async exactSearch() {
            this.objects = await this.searchFromDesignNew('registry/searchByData', 'key', ['piva', this.search_piva.trim()], false)
        },
        async updateSearch() {
            this.searching = true
            let c_filter = ['client']
            if (this.filter.org){
                c_filter.push(['org', this.$store.state.user.org_id])
            }
            let clients = await this.searchFromDesignNew('registry/searchByData', 'all_keys', c_filter, false)
            // console.log("clients", clients)
            let selectors = []
            if (this.filter.city){
                let city = ''
                if ( typeof(this.filter.city) === "string") {
                    city= this.filter.city.toLowerCase()
                } else {
                    city= this.filter.city.name.toLowerCase()
                }
                selectors.push(['city', city])
            }
            if (this.filter.district){
                let district = ''
                if ( typeof(this.filter.district) === "string") {
                    district= this.filter.district.toLowerCase()
                    let tmp = _.find(this.districts.districts, function(o) { 
                        return o.name.toLowerCase() == district 
                    });
                    if (tmp) {
                        district = tmp.id.toLowerCase()
                    }
                } else {
                    district= this.filter.district.id.toLowerCase()
                }
                selectors.push(['district', district])
            }
            if (selectors.length > 0){
                let res = await this.searchFromDesignNew('registry/searchByData', 'all_keys', selectors, false)
                // console.log('LOCATION FILTER', res)
                clients = _.intersectionWith(clients, res, function(clientVal, locVal){
                    return clientVal._id == locVal.value
                })
            }
            // console.log('SEARCH WITHOUT FILTER', clients)
            if (this.filter.search) {
                let text_res = await this.searchFromDesignNew('clients/searchByText', 'text', this.filter.search, false)
                clients = _.intersectionWith(clients, text_res, function(arrVal, othVal){
                    return arrVal._id == othVal._id
                })
            }
            if (this.filter.contact_search) {
                let contact_res = await this.searchFromDesignNew('registry/searchByContact', 'text', this.filter.contact_search, false)
                clients = _.intersectionWith(clients, contact_res, function(arrVal, othVal){
                    return arrVal._id == othVal._id
                })
            }

            if (!useRemoteConnection(this.$store.state.user.roles)) {
                try {
                    let a_support_ids = await this.$store.state.$pouch.allDocs(support_db)
                    let support_ids = _.map(a_support_ids.rows, 'id');
                    clients = _.filter(clients, function(client) { 
                        return _.indexOf(support_ids, client._id) >=0 
                    });
                } catch (exception) {
                    console.log('SUPPORTDB not exists')
                }
            }
            this.objects = this.orderBy(clients, this.sort_fields)
            console.log('$$ sorting', this.sort_fields)
            
            
            this.searching = false
        }

    },
    async beforeMount(){
        console.log('before_mount')
        this.districts = await this.$store.state.$pouch.get('system', "district:ITALIA")
        let filter = this.restore_history_params()
        console.log('*****', this.page, this.sort_fields)
        this.filtered_org = null
        if (filterByOrg('client', 'view_org', this.$store.state.user.roles)) {
            this.filtered_org = this.$store.state.user.org_id
        }
        if (!filter) {
            this.resetSearch()
        } else {
            this.advanced_search = true
            this.filter = Object.assign({}, this.filter, filter)
        }
        if (this.filtered_org) {
            this.filter.org = this.filtered_org
        }
        await this.updateSearch()
    },
    created(){
    }
}
</script>

<style>

</style>